export default __webpack_public_path__ + "2a974518305b727bbc31f191daf36091.svg";